module.exports = __webpack_public_path__ + "static/media/carer-at-home.6373c7db.png";